module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-dropdown', {
    attrs: {
      "aria-role": "list"
    }
  }, [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "slot": "trigger"
    },
    slot: "trigger"
  }, [_c('span', [_vm._v("Click me!")]), _vm._v(" "), _c('b-icon', {
    attrs: {
      "icon": "menu-down"
    }
  })], 1), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "aria-role": "listitem"
    }
  }, [_vm._v("Action")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "aria-role": "listitem"
    }
  }, [_vm._v("Another action")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "aria-role": "listitem"
    }
  }, [_vm._v("Something else")])], 1), _vm._v(" "), _c('b-dropdown', {
    attrs: {
      "hoverable": "",
      "aria-role": "list"
    }
  }, [_c('button', {
    staticClass: "button is-info",
    attrs: {
      "slot": "trigger"
    },
    slot: "trigger"
  }, [_c('span', [_vm._v("Hover me!")]), _vm._v(" "), _c('b-icon', {
    attrs: {
      "icon": "menu-down"
    }
  })], 1), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "aria-role": "listitem"
    }
  }, [_vm._v("Action")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "aria-role": "listitem"
    }
  }, [_vm._v("Another action")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "aria-role": "listitem"
    }
  }, [_vm._v("Something else")])], 1), _vm._v(" "), _c('b-dropdown', {
    attrs: {
      "disabled": "",
      "aria-role": "list"
    }
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "slot": "trigger"
    },
    slot: "trigger"
  }, [_c('span', [_vm._v("Disabled")]), _vm._v(" "), _c('b-icon', {
    attrs: {
      "icon": "menu-down"
    }
  })], 1), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "aria-role": "listitem"
    }
  }, [_vm._v("Action")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "aria-role": "listitem"
    }
  }, [_vm._v("Another action")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "aria-role": "listitem"
    }
  }, [_vm._v("Something else")])], 1), _vm._v(" "), _c('b-dropdown', {
    attrs: {
      "aria-role": "list"
    }
  }, [_c('p', {
    staticClass: "tag is-success",
    attrs: {
      "slot": "trigger",
      "role": "button"
    },
    slot: "trigger"
  }, [_vm._v("\n                Custom trigger\n            ")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "aria-role": "listitem"
    }
  }, [_vm._v("Action")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "aria-role": "listitem"
    }
  }, [_vm._v("Another action")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "aria-role": "listitem"
    }
  }, [_vm._v("Something else")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19806782"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/dropdown/examples/ExSimple.vue
// module id = 1065
// module chunks = 11 50